// `clientes.regiao` / `colaboradores.regiao` é um código solto vindo do TOTVS
// ("009", "011"...) e não existe tabela de catálogo que o traduza — sozinho ele
// não diz nada a quem lê a tela. Os rótulos seguem a Consulta Padrão de Região
// do Protheus, que é POR EMPRESA: Suplen (01) e TopMed (02) usam os mesmos
// códigos com significados diferentes (010/011 são MG/GO trocados, e 014/015
// nem são estado na Suplen). Como este front é o mesmo deploy nas duas, a
// tabela sai do prefixo da filial: 02xx = TopMed; o resto (01xx e a Neurovasc
// 03xx, cujos clientes vêm do cadastro da empresa 01) = Suplen. Conferido em
// 2026-09-25 cruzando clientes.regiao com endereco.uf nos dois bancos. Códigos
// fora da tabela (antigos como 006/008, ou novos que surgirem no ERP antes de
// entrar aqui) aparecem só com o número, em vez de uma sigla errada.
export const REGIOES_SUPLEN: Record<string, string> = {
  '009': 'DF',
  '010': 'MG',
  '011': 'GO',
  '012': 'MT',
  '013': 'MS',
  '014': 'ELETROFISIOLOGIA',
  '015': 'TRAT. FERIDAS',
};

export const REGIOES_TOPMED: Record<string, string> = {
  '009': 'DF',
  '010': 'GO',
  '011': 'MG',
  '012': 'MT',
  '013': 'MS',
  '014': 'SP',
  '015': 'DESCARTAVEIS',
};

export const tabelaRegioes = (filialCodigo?: string): Record<string, string> =>
  (filialCodigo ?? '').trim().startsWith('02') ? REGIOES_TOPMED : REGIOES_SUPLEN;

export const rotuloRegiao = (codigo?: string, filialCodigo?: string): string => {
  const cod = (codigo ?? '').trim();
  if (!cod) return '—';
  const nome = tabelaRegioes(filialCodigo)[cod];
  return nome ? `${cod} — ${nome}` : cod;
};

type ColaboradorComRegiao = {
  codigo?: string | null;
  regiao?: string | null;
  gerente_codigo?: string | null;
  gerente_regional_codigo?: string | null;
  gerente_nacional_codigo?: string | null;
  supervisor_codigo?: string | null;
  coordenador_codigo?: string | null;
};

// Campos em que o Protheus aponta o superior de cada vendedor.
const CAMPOS_HIERARQUIA = [
  'gerente_codigo',
  'gerente_regional_codigo',
  'gerente_nacional_codigo',
  'supervisor_codigo',
  'coordenador_codigo',
] as const;

const texto = (valor?: string | null): string => String(valor ?? '').trim();

/**
 * Regiões de um usuário que vem do Protheus: a do próprio cadastro mais as dos
 * colaboradores que o têm como superior (gerente, supervisor, coordenador).
 * Para gerente é a mesma regra da API na lista de clientes do gerente
 * (`listarClientesPorGerente`, regiões dos vendedores com `gerente_codigo`).
 */
export const regioesDoColaborador = (
  colaborador: ColaboradorComRegiao | null | undefined,
  todos: ColaboradorComRegiao[] = []
): string[] => {
  const regioes = new Set<string>();
  const propria = texto(colaborador?.regiao);
  if (propria) regioes.add(propria);

  const codigo = texto(colaborador?.codigo);
  if (codigo) {
    todos.forEach((outro) => {
      const subordinado = CAMPOS_HIERARQUIA.some((campo) => texto(outro?.[campo]) === codigo);
      const regiao = texto(outro?.regiao);
      if (subordinado && regiao) regioes.add(regiao);
    });
  }

  return Array.from(regioes).sort();
};
